<template>
  <div 
    class="fts-automation-debugpoint"
    :class="{'automation-debugpoint--active': debugValue}"
    @click="toggleDebug">
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  model: {
    prop: "value",
    event: "updateValue",
  },
  methods: {
    toggleDebug() {
      this.debugValue = !this.debugValue;
    },
  },
  computed: {
    debugValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('updateValue', val);
        this.$emit('input', val);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-automation-debugpoint {
  height: 1rem;
  width: 1rem;
  border: 1px solid var(--fts-block-danger);
  border-radius: 50%;
  background: #fff;;
  cursor: pointer;
  transition: .3s all ease-in-out;
  &.automation-debugpoint--active {
    background: var(--fts-block-danger);
  }
}
</style>